import { Blog, BlogPost } from "@/types";

export const getLatestBlogPosts = (
  blog: Blog | null,
  limit?: number,
): BlogPost[] => {
  const sortedItems = [...(blog?.items ?? [])].sort(
    (a, b) =>
      new Date(b.date_modified).getTime() - new Date(a.date_modified).getTime(),
  );

  return typeof limit === "number" ? sortedItems.slice(0, limit) : sortedItems;
};
